import { useEffect } from "react";

// Minimal SEO helper: sets document.title, meta description, canonical, and a
// robots noindex tag for drafts. No dependency needed for a small SPA.
export function Seo({
  title,
  description,
  noindex,
  path,
}: {
  title: string;
  description?: string;
  noindex?: boolean;
  path?: string;
}) {
  useEffect(() => {
    document.title = `${title} · PulsePanels Help`;

    setMeta("description", description ?? "");
    setMeta("robots", noindex ? "noindex, nofollow" : "index, follow");

    if (path) {
      let link = document.querySelector<HTMLLinkElement>("link[rel=canonical]");
      if (!link) {
        link = document.createElement("link");
        link.rel = "canonical";
        document.head.appendChild(link);
      }
      link.href = `https://help.pulsepanels.com${path}`;
    }
  }, [title, description, noindex, path]);

  return null;
}

function setMeta(name: string, content: string) {
  let el = document.querySelector<HTMLMetaElement>(`meta[name="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.name = name;
    document.head.appendChild(el);
  }
  el.content = content;
}
